/**
 * Harvest Monitoring API Configuration
 * Centralized API endpoint constants for harvest monitoring
 */

export const HARVEST_MONITORING_API_CONFIG = {
    BASE_PATH: '/api/report/pijar/harvest',
    ENDPOINTS: {
        MONITORING: '/monitoring',
        MONITORING_SPB: '/monitoring-spb',
    }
} as const;

/**
 * Get full endpoint URL
 */
export const getHarvestMonitoringEndpoint = (endpoint: keyof typeof HARVEST_MONITORING_API_CONFIG.ENDPOINTS): string => {
    return `${HARVEST_MONITORING_API_CONFIG.BASE_PATH}${HARVEST_MONITORING_API_CONFIG.ENDPOINTS[endpoint]}`;
};
